import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Button,
  Container,
  Paper,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import Toolbar from "./Toolbar";
import {
  apiEndpoints,
  apiPutRequest,
  apiDeleteRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { addCreatedAndUpdatedFields } from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import KmTabPanel from "src/components/common/KmTabPanel";
import TabsNavBar from "../TabsNavBar";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { useNavigate } from "react-router-dom";
import DescriptionIcon from "@material-ui/icons/Description";
import KmPageTitle from "src/components/layout/KmPageTitle";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const RowButtons = (row, customHandlers, ...rest) => {
  return (
    <Box>
      {!row.documentNotApplicable && row.documentStructNodeId ? (
        <Tooltip title="Dokumenty">
          <IconButton
            aria-label="dokumenty"
            component={RouterLink}
            to={`/dokumenty/${row.documentStructNodeId}`}
          >
            <DescriptionIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
      {row.relatedCount > 0 ? (
        <Tooltip title="Podgląd">
          <IconButton
            aria-label="podgląd"
            component={RouterLink}
            to={`/zarzadzanieglosowania/podgladglosowania/${row.id}`}
          >
            <SearchIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
      <Tooltip title="Edytuj">
        <IconButton
          aria-label="edytuj"
          component={RouterLink}
          to={`/zarzadzanieglosowania/edycjaglosowania/${row.id}`}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Rozpocznij">
        <IconButton
          aria-label="rozpocznij głosowanie"
          onClick={() => customHandlers.startHandler(row)}
        >
          <PlayArrowIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

const Votings = ({
  enableGlobalLoader,
  disableGlobalLoader,
  setLogoutUser,
}) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [dialogOpen, setOpen] = useState(false);
  const [dialogStartOpen, setStartOpen] = useState(false);
  const [startedVoting, setStartedVoting] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getManagmentVotings.path, "preparing", true)
      .then((data) => {
        disableGlobalLoader();
        setRows(
          addCreatedAndUpdatedFields(
            data,
            "createdBy",
            "createdAt",
            "updatedBy",
            "updatedAt",
            ", "
          )
        );
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const startHandler = (row) => {
    setStartedVoting(row);
    handleClickStartOpen(row);
  };

  const headCells = [
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      width: "10%",
      customHandlers: { startHandler },
      component: RowButtons,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      fieldName: "title",
      sortable: true,
      main: true,
      label: "Tytuł głosowania",
      width: "25%",
    },
    {
      id: "startsAt",
      numeric: false,
      disablePadding: false,
      fieldName: "startsAt",
      sortable: true,
      main: false,
      label: "Data rozpoczęcia",
      width: "15%",
    },
    {
      id: "endsAt",
      numeric: false,
      disablePadding: false,
      fieldName: "endsAt",
      sortable: true,
      main: false,
      label: "Data zakończenia",
      width: "15%",
    },
    {
      id: "created",
      fieldName: "createdAt",
      fieldName2: "createdBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto utworzył",
      width: "15%",
    },
    {
      id: "updated",
      fieldName: "updatedAt",
      fieldName2: "updatedBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto zmodyfikował",
      width: "15%",
    },
  ];

  const onSelectedRowIdsChanged = (viewSelectedRowIds) => {
    setSelectedRowIds(viewSelectedRowIds);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    enableGlobalLoader();
    setOpen(false);
    apiDeleteRequest(apiEndpoints.deleteVotings.path, selectedRowIds, true)
      .then((data) => {
        disableGlobalLoader();
        setReloadCounter(reloadCounter + 1);
      })
      .catch((error) => {
        disableGlobalLoader();
        navigate("/zarzadzanieglosowania/wprzygotowaniu");
      });
  };

  const handleClickStartOpen = () => {
    setStartOpen(true);
  };

  const handleStartDialogClose = () => {
    setStartOpen(false);
  };

  const handleStart = () => {
    if (startedVoting) {
      enableGlobalLoader();

      apiPutRequest(
        apiEndpoints.setVotingStatus.path,
        {
          id: startedVoting.id,
          action: "start",
          reason: "start",
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          setStartOpen(false);

          setReloadCounter(reloadCounter + 1);
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    } else {
    }
  };

  return (
    <Page className={classes.root} title="Głosowania w przygotowaniu">
      <KmPageTitle>Głosowania</KmPageTitle>
      <Container maxWidth={false}>
        <Paper>
          <TabsNavBar value={0} />
          <KmTabPanel value={0} index={0}>
            <Page className={classes.root}>
              <Container maxWidth={false}>
                <Toolbar dialogHandler={handleClickOpen} />
                <Box mt={3}>
                  <KmFilteredTable
                    headCells={headCells}
                    rows={rows}
                    onSelectedRowIdsChange={onSelectedRowIdsChanged}
                  />
                  <Dialog
                    fullScreen={fullScreen}
                    open={dialogOpen}
                    onClose={handleClose}
                    aria-labelledby="responsive-dialog-title"
                  >
                    <DialogTitle id="responsive-dialog-title">
                      {"Usuwanie głosowań"}
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Czy na na pewno chcesz usunąć zaznaczone elementy?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button autoFocus onClick={handleClose} color="primary">
                        Nie
                      </Button>
                      <Button onClick={handleDelete} color="primary" autoFocus>
                        Tak
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    fullScreen={fullScreen}
                    open={dialogStartOpen}
                    onClose={handleStartDialogClose}
                    aria-labelledby="responsive-dialog-title"
                  >
                    <DialogTitle id="responsive-dialog-title">
                      {"Rozpoczęcie głosowania"}
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Czy na na pewno chcesz rozpocząć głosowanie "
                        {startedVoting ? startedVoting.title : "-"}"?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        autoFocus
                        onClick={handleStartDialogClose}
                        color="primary"
                      >
                        Nie
                      </Button>
                      <Button onClick={handleStart} color="primary" autoFocus>
                        Tak
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Box>
              </Container>
            </Page>
          </KmTabPanel>
        </Paper>
      </Container>

      {/* <Container maxWidth={false}>
        <Toolbar dialogHandler={handleClickOpen} />
        <Box mt={3}>
          <KmFilteredTable
            headCells={headCells}
            rows={rows}
            onSelectedRowIdsChange={onSelectedRowIdsChanged}
          />
          <Dialog
            fullScreen={fullScreen}
            open={dialogOpen}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              {"Usuwanie głosowań"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Czy na na pewno chcesz usunąć zaznaczone elementy?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClose} color="primary">
                Nie
              </Button>
              <Button onClick={handleDelete} color="primary" autoFocus>
                Tak
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container> */}
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
});

export default connect(null, mapDispatchToProps)(Votings);
